import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
	ArrowLeftIcon,
	BellIcon,
	ChevronDownIcon,
	GearIcon,
	IndoFlagIcon,
} from "@/assets/svg";
import { LogoutUseCase } from "@/feature/auth";

interface MainHeaderProps {
	readonly title: string;
	readonly onBack?: () => void;
}

export function MainHeader({ title, onBack }: MainHeaderProps) {
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const [isSettingsDropdownOpen, setIsSettingsDropdownOpen] = useState(false);
	const navigate = useNavigate();

	const handleLogout = () => {
		LogoutUseCase();
		navigate("/login");
	};

	return (
		<div className="flex justify-between items-center bg-white mb-4">
			<div className="flex items-center gap-2">
				{onBack && (
					<Button
						variant="ghost"
						size="sm"
						icon={<ArrowLeftIcon />}
						aria-label="Back to previous page"
						htmlType="button"
						className="mr-1 !w-[38px] !h-[38px] !min-w-[38px] !p-0"
						onClick={onBack}
					/>
				)}
				<h1 className="font-bold text-lg leading-[22px] tracking-[0.005em]">{title}</h1>
			</div>

			<div className="flex items-center gap-2">
				<div
					className="flex items-center gap-1 cursor-pointer"
					onClick={() => setIsDropdownOpen(!isDropdownOpen)}
				>
					<div className="flex items-center gap-1">
						<IndoFlagIcon />
						<div className="font-medium text-base leading-6">ID</div>
					</div>
					<ChevronDownIcon />
				</div>

				<button className="bg-transparent border-none rounded-lg cursor-pointer transition-all duration-200 w-[38px] h-[38px] p-0 hover:bg-[#f0f0f0] active:bg-[#e0e0e0]" aria-label="Notifications">
					<BellIcon />
				</button>

				<div
					className="relative flex items-center"
					onMouseEnter={() => setIsSettingsDropdownOpen(true)}
					onMouseLeave={() => setIsSettingsDropdownOpen(false)}
				>
					<button
						className="bg-transparent border-none rounded-lg cursor-pointer transition-all duration-200 w-[38px] h-[38px] p-0 hover:bg-[#f0f0f0] active:bg-[#e0e0e0]"
						aria-label="Settings"
						aria-expanded={isSettingsDropdownOpen}
						aria-haspopup="menu"
					>
						<GearIcon />
					</button>

					{isSettingsDropdownOpen && (
						<div className="absolute right-0 top-full z-50 min-w-[120px] pt-1">
							<div className="bg-white border border-gray-200 rounded-lg shadow-lg py-1">
								<button
									type="button"
									onClick={handleLogout}
									className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 transition-colors cursor-pointer bg-transparent border-none"
								>
									Logout
								</button>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}
